export interface GuideBox {
	x: number;
	y: number;
	width: number;
	height: number;
}

export interface GuidePlacement {
	left: number;
	top: number;
	side: "below" | "above" | "right" | "left" | "pinned";
}

/** Jarak kartu dari target dan dari tepi layar. */
export const GUIDE_GAP = 14;
export const GUIDE_MARGIN = 12;

const clamp = (v: number, min: number, max: number) =>
	Math.max(min, Math.min(v, Math.max(min, max)));

/**
 * Letak kartu panduan relatif target: bawah, atas, kanan, kiri — mana yang muat
 * tanpa menutupi target dan tanpa masuk ke header, sidebar, atau kolom panel
 * (`area` = area konten terlihat; bila tak diberikan = seluruh viewport, kecuali
 * `avoidRight`). Bila tak ada yang muat (target memenuhi layar), kartu dipasang
 * di dasar area.
 */
export function placeGuideCard(input: {
	rect: GuideBox;
	viewport: { width: number; height: number };
	card: { width: number; height: number };
	avoidRight?: number;
	area?: { left: number; top: number; right: number; bottom: number };
}): GuidePlacement {
	const { rect, viewport, card } = input;
	const area = input.area ?? {
		left: 0,
		top: 0,
		right: viewport.width - (input.avoidRight ?? 0),
		bottom: viewport.height,
	};
	const minLeft = area.left + GUIDE_MARGIN;
	const minTop = area.top + GUIDE_MARGIN;
	const maxLeft = area.right - card.width - GUIDE_MARGIN;
	const maxTop = area.bottom - card.height - GUIDE_MARGIN;
	const centeredLeft = clamp(
		rect.x + rect.width / 2 - card.width / 2,
		minLeft,
		maxLeft,
	);

	const below = rect.y + rect.height + GUIDE_GAP;
	if (below <= maxTop) return { left: centeredLeft, top: below, side: "below" };

	const above = rect.y - GUIDE_GAP - card.height;
	if (above >= minTop) return { left: centeredLeft, top: above, side: "above" };

	const sideTop = clamp(rect.y, minTop, maxTop);
	const right = rect.x + rect.width + GUIDE_GAP;
	if (right <= maxLeft) return { left: right, top: sideTop, side: "right" };

	const left = rect.x - GUIDE_GAP - card.width;
	if (left >= minLeft) return { left, top: sideTop, side: "left" };

	return {
		left: clamp((area.left + area.right - card.width) / 2, minLeft, maxLeft),
		top: Math.max(minTop, maxTop),
		side: "pinned",
	};
}
